/* Each variable here will be exported to window.ReactComponents as the setup in make-webpack-config.js */

// Styles
require("assets/css/sass/app.scss");
// Uncomment theses scss to use card-edit.php
// require("assets/css/sass/card.scss");
// require("assets/css/sass/card-edit.scss");

// Components Styles - alphabetical order
require("assets/css/sass/components/activity.scss");
require("assets/css/sass/components/activity-input.scss");
require("assets/css/sass/components/boolean-input.scss");
//require("assets/css/sass/components/collapse-text.scss");
require("assets/css/sass/components/datetime-picker.scss");
require("assets/css/sass/components/coachmark.scss");
require("assets/css/sass/components/deal-lost-popbox.scss");
require("assets/css/sass/components/deal-ranking.scss");
require("assets/css/sass/components/deal-status.scss");
// require("assets/css/sass/components/deal-status-selector.scss");
require("assets/css/sass/components/dropdown.scss");
// require("assets/css/sass/components/entities.scss");
require("assets/css/sass/components/entity-suggestions.scss");
require("assets/css/sass/components/expand-box.scss");
require("assets/css/sass/components/filters.scss");
require("assets/css/sass/components/google-calendar.scss");
require("assets/css/sass/components/hover.scss");
require("assets/css/sass/components/icon-button.scss");
require("assets/css/sass/components/input-text.scss");
require("assets/css/sass/components/listing.scss");
require("assets/css/sass/components/labeled-input.scss");
require("assets/css/sass/components/listing-filter.scss");
require("assets/css/sass/components/listing-loader.scss");
require("assets/css/sass/components/loader.scss");
require("assets/css/sass/components/monthly-summary-box.scss");
require("assets/css/sass/components/number-picker.scss");
require("assets/css/sass/components/plan-selector.scss");
require("assets/css/sass/components/plan-card-loading.scss");
//require("assets/css/sass/components/product-tag.scss");
require("assets/css/sass/components/prompt.scss");
require("assets/css/sass/components/rounded-button.scss");
require("assets/css/sass/components/social.scss");
require("assets/css/sass/components/upload.scss");
require("assets/css/sass/components/upload-progress.scss");
require("assets/css/sass/components/user-avatar.scss");
require("assets/css/sass/components/user-select-box.scss");
require("assets/css/sass/components/user-selector.scss");
require("assets/css/sass/components/user-selector-loading.scss");
require("assets/css/sass/components/step-progress-bar.scss");
require("assets/css/sass/components/history-params.scss");
require("assets/css/sass/react-select.scss");
// TODO: Move this require() for .scss files into their owner components, but this will break mocha unit tests
// TODO: A solution would be to create a function/loader that ignore the css require() when NODE_ENV=test

module.exports.captureError = require("app/util/browser/capture-error.js");
require("app/util/browser/react-performance.js");
// Components
module.exports.DealsListingTotalValue = require("app/shared/components/List/deals-listing-total-value");
module.exports.DealLostPopboxContainer = require("app/shared/components/DealLostPopbox/deal-lost-popbox-container");
module.exports.DealWonPopboxContainer = require("app/shared/components/DealWonPopbox/deal-won-popbox-container");
//module.exports.DealCardContainer = require("app/screens/Card/components/Deal/deal-card-container");
//module.exports.OrganizationCardContainer = require("app/screens/Card/components/Organization/organization-card-container");
//module.exports.PersonCardContainer = require("app/screens/Card/components/Person/person-card-container");
module.exports.Listing = require("app/shared/components/List/listing");
module.exports.Hover = require("app/shared/components/Hover/hover");
module.exports.ListingFilter = require("app/shared/components/List/listing-filter");
module.exports.Loader = require("app/shared/components/Loader/loader");
module.exports.PromptAccountPrivacyChange = require("app/shared/components/Prompt/prompt-account-privacy-change");
module.exports.PromptContainer = require("app/shared/components/Prompt/prompt-container");
module.exports.UserAvatar = require("app/shared/components/User/user-avatar");
module.exports.Signal = require("app/shared/components/Signal/signal");
module.exports.ActivitiesListing = require("app/screens/Activity/components/ActivityList/activities-listing");
module.exports.ActivityInput = require("app/screens/Activity/components/ActivityInput/activity-input");
module.exports.ActivitiesWrapper = require("app/screens/Activity/components/ActivityList/activities-wrapper");
module.exports.CalendarWrapper = require("app/screens/Activity/components/Calendar/calendar-wrapper");
module.exports.GoogleCalendarIntegrationContainer = require("app/screens/Integration/components/GoogleCalendar/google-calendar-integration-container");
module.exports.MonthlySummaryBox = require("app/screens/Report/MonthlySummaryBox/monthly-summary-box");
module.exports.userPreferences = require("app/util/browser/user-preferences");
module.exports.PlanSelectorContainer = require("app/screens/Pricing/components/PlanSelector/plan-selector-container");
module.exports.DowngradePrompt = require("app/screens/Pricing/components/DowngradePrompt/downgrade-prompt");
module.exports.UndoImportPrompt = require("app/screens/Import/components/UndoImportPrompt/undo-import-prompt");
module.exports.AccountRemovalPrompt = require("app/screens/Account/components/account-removal-prompt");
module.exports.PromptActivateTrial = require("app/shared/components/Prompt/prompt-activate-trial");
module.exports.TeamSelectorContainer = require("app/shared/components/TeamSelector/team-selector-container");
module.exports.AddTeamPrompt = require("app/shared/components/TeamSelector/add-team-prompt");
module.exports.TeamConfig = require("app/screens/Team/components/TeamConfig/team-config");
module.exports.ExportDealsButton = require("app/screens/Deals/components/ExportDealsButton/export-deals-button");
module.exports.ExportPeopleButton = require("app/screens/People/components/ExportPeopleButton/export-people-button");
module.exports.ExportOrganizationsButton = require("app/screens/Organizations/components/ExportOrganizationsButton/export-organizations-button");
module.exports.ExportActivitiesButton = require("app/screens/Activity/components/ExportActivitiesButton/export-activities-button");
module.exports.DealsVisualizationButtons = require("app/shared/components/List/deals-visualization-buttons.jsx");
module.exports.FreezeDealButton = require("app/screens/Deals/components/FreezeDealButton/freeze-deal-button");
module.exports.CopyBox = require("app/shared/components/CopyBox/copy-box.jsx");
module.exports.CurrencyValue = require("app/shared/components/List/currency-value");
//module.exports.UserSelectorContainer = require("app/shared/components/UserSelector/user-selector-container");
module.exports.StepProgressBar = require("app/shared/components/StepProgressBar/step-progress-bar");
// module.exports.RDStation = require("app/screens/Integration/components/RDStation/rd-station");
module.exports.Dashboard = require("app/screens/Dashboard/components/Dashboard/dashboard");
module.exports.HistoryParams = require("app/screens/Activity/components/HistoryParams/history-params");
module.exports.ExportAccountData = require("app/shared/components/ExportButton/export-account-data");
module.exports.RDStationIntegration = require("app/screens/Integration/components/RDStation/rd-station-integration");
module.exports.Coachmark = require("app/shared/components/Coachmark/coachmark");
module.exports.EntitySuggestions = require("app/shared/components/EntitySuggestions/entity-suggestions");

// Uncomment theses components to use card-edit.php
// module.exports.DealStatusBox = require("app/shared/components/Hover/deal-status");
// module.exports.Button = require("app/shared/components/Button/button");

// Actions
module.exports.ListingActions = require("app/shared/actions/listing-actions");
module.exports.ActivitiesListingActions = require("app/screens/Activity/actions/activities-listing-actions");
module.exports.ActivityInputActions = require("app/screens/Activity/actions/activity-input-actions");
module.exports.SignalActions = require("app/shared/actions/signal-actions");

// i18n file
module.exports.i18n = require("app/util/i18n/i18n");

// Currency Functions
module.exports.CurrencyFormatter = require("app/util/formatter/currency");

// Activity localStorage methods
module.exports.ActivityDraft = require("app/util/browser/activity-draft");
module.exports.URLUtil = require("app/util/browser/url");

// API
module.exports.APIV2 = require("app/util/api/agendor-api");
module.exports.APICaller = require("app/util/api/api-caller");

// Libraries
module.exports.moment = require("moment");
module.exports.momentTimezone = require("moment-timezone");
module.exports.underscore = require("underscore");
module.exports.textAreaAutosize = require("autosize");
module.exports.uuid = require("uuid")



// WEBPACK FOOTER //
// ./app/index.js